import { render, staticRenderFns } from "./helpIndex.vue?vue&type=template&id=40326e94&scoped=true"
import script from "./helpIndex.vue?vue&type=script&lang=js"
export * from "./helpIndex.vue?vue&type=script&lang=js"
import style0 from "./helpIndex.vue?vue&type=style&index=0&id=40326e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40326e94",
  null
  
)

export default component.exports